
export default new class ClipboardUtility {
  // eslint-disable-next-line class-methods-use-this
  copy(value: string): void {
    if (navigator.clipboard) {
      // clipboard API
      navigator.clipboard.writeText(value);
      // @ts-ignore
    } else if (window.clipboardData) {
      // Internet Explorer
      // @ts-ignore
      window.clipboardData.setData('Text', value);
    } else {
      // use execCommand
      const listener = (e: ClipboardEvent) => {
        e.clipboardData?.setData('text/plain', value);
        e.preventDefault();
        document.removeEventListener('copy', listener);
      };
      document.addEventListener('copy', listener);
      const input = document.createElement('input');
      document.body.appendChild(input);
      input.value = value;
      input.select();
      document.execCommand('copy');
      document.body.removeChild(input);
    }
  }
}();
